import { render, staticRenderFns } from "./IndicatorsComponent.vue?vue&type=template&id=e83173ca&scoped=true"
import script from "./IndicatorsComponent.vue?vue&type=script&lang=js"
export * from "./IndicatorsComponent.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsComponent.vue?vue&type=style&index=0&id=e83173ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83173ca",
  null
  
)

export default component.exports